import  { useContext } from "react";
import { useAuth } from "../Context/AuthContext";
import { useLocation } from "react-router-dom";
import {
  SessionPopup,
} from "../Common/PopupStyles/PopupComponent";
import { DynamicContext } from "../Context/DynamicContext";
import SessionBlockedIcon from "../Assets/Images/Session_Blocked_Icon.png";
import SessionExpiredIcon from "../Assets/Images/Session_Expired_Icon.png";
import { handleLogoutCommon } from "../Common/Common-Function/CommonFunctions";
export default function SessionExpiredToast() {
  const { sessionExpired, setSessionExpired } = useAuth();
  const location = useLocation();
  const publicRoutes = [
    "/",
    "/login",
    "/signup",
    "/join",
    "/forgot-password",
    "/admin-signup",
    "/member-signup",
    "/careers",
  ];
  const {
    setUserDetails,
    setShowResumeParser,
    setUploadedResumes,
    setIncompleteFiles,
    setParsedData,
    setIncompleteData,
    setRunSetId,
    setErrorMessages,
    setSuccessMessages,
    setShowFailedTab,
    setIsParsingComplete,
  } = useContext(DynamicContext);
  const handleSession = () => {
    handleLogoutCommon({
      setUserDetails,
      setShowResumeParser,
      setUploadedResumes,
      setIncompleteFiles,
      setParsedData,
      setIncompleteData,
      setRunSetId,
      setErrorMessages,
      setSuccessMessages,
      setShowFailedTab,
      setIsParsingComplete,
      afterLogoutNavigate: () => {
        window.location.href = "/";
      },
    });
    setSessionExpired(false);
  };

  if (
    publicRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/board/") ||
    location.pathname.startsWith("/job/view/")
  ) {
    return null;
  }

  const isBlocked = localStorage.getItem("sessionExpiredReason") === "blocked";

  return (
    <SessionPopup
      isOpen={sessionExpired}
      onClose={() => handleSession()}
      onConfirm={() => {
        handleSession();
      }}
      title={isBlocked ? "Session Blocked!" : "Session Expired!"}
      headerIcon={isBlocked ? SessionBlockedIcon : SessionExpiredIcon}
      message={
        isBlocked ? (
          <span
            style={{
              display: "block",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Your credentials are logged in elsewhere.
            <br />
            <span style={{ color: "gray", fontSize: "16px" }}>
              Please log in again.
            </span>
          </span>
        ) : (
          <span
            style={{
              display: "block",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Your session has expired.
            <br />
            <span style={{ color: "gray", fontSize: "16px" }}>
              Please login again to continue.
            </span>
          </span>
        )
      }
      // animationData={TimeoutAnimation}
      confirmLabel="Login"
      cancelLabel={null}
    />
  );
}
